(function () {
  const LABEL = ".product-card .variant-option__button-label";

  /**
   * @param {HTMLElement} label
   */
  function findCardParts(label) {
    const card = label.closest(".product-card");
    const swatch = label.querySelector(".swatch");
    const primaryImg = card && card.querySelector(".primary-image");
    return {
      card,
      swatch: swatch instanceof HTMLElement ? swatch : null,
      primaryImg: primaryImg instanceof HTMLImageElement ? primaryImg : null,
    };
  }

  /**
   * @param {HTMLElement} label
   */
  function previewImage(label) {
    const { swatch, primaryImg } = findCardParts(label);
    if (!swatch || !primaryImg) return;
    const newImage = swatch.getAttribute("data-image");
    if (newImage) primaryImg.src = newImage;
  }

  /**
   * @param {HTMLElement} label
   */
  function revertImage(label) {
    const { card, primaryImg } = findCardParts(label);
    if (!card || !primaryImg) return;
    const activeSwatch = card.querySelector(
      ".variant-option__button-label.active .swatch",
    );
    const activeSwatchElement =
      activeSwatch instanceof HTMLElement ? activeSwatch : null;
    const fallback =
      (activeSwatchElement && activeSwatchElement.getAttribute("data-image")) ||
      primaryImg.getAttribute("data-default");
    if (fallback) primaryImg.src = fallback;
  }

  /**
   * @param {HTMLElement} label
   */
  function activate(label) {
    const { card, swatch, primaryImg } = findCardParts(label);
    if (!card) return;
    card
      .querySelectorAll(".variant-option__button-label")
      .forEach((buttonLabel) => buttonLabel.classList.remove("active"));
    card
      .querySelectorAll(".swatch")
      .forEach((swatchEl) => swatchEl.classList.remove("active"));
    label.classList.add("active");
    if (swatch) swatch.classList.add("active");
    if (swatch && primaryImg) {
      const newImage = swatch.getAttribute("data-image");
      if (newImage) primaryImg.src = newImage;
    }
  }

  /**
   * @param {EventTarget | null} target
   * @returns {HTMLElement | null}
   */
  function getLabelFromTarget(target) {
    if (!(target instanceof Element)) return null;
    const label = target.closest(LABEL);
    return label instanceof HTMLElement ? label : null;
  }

  // mouseenter/leave don't bubble — use capture phase delegation.
  document.addEventListener(
    "mouseover",
    /** @param {MouseEvent} e */ (e) => {
      const label = getLabelFromTarget(e.target);
      const related = e.relatedTarget instanceof Node ? e.relatedTarget : null;
      if (label && !label.contains(related)) previewImage(label);
    },
  );

  document.addEventListener(
    "mouseout",
    /** @param {MouseEvent} e */ (e) => {
      const label = getLabelFromTarget(e.target);
      const related = e.relatedTarget instanceof Node ? e.relatedTarget : null;
      if (label && !label.contains(related)) revertImage(label);
    },
  );

  document.addEventListener(
    "click",
    /** @param {MouseEvent} e */ (e) => {
      const label = getLabelFromTarget(e.target);
      if (label) activate(label);
    },
  );
})();
